import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaDateInputComponent } from './viva-date-input.component';

@NgModule({
  declarations: [
    VivaDateInputComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaDateInputComponent
  ]
})
export class  VivaDateInputModule { }
